<button mat-icon-button [matMenuTriggerFor]="notificationMenu" class="nav-notification-icons" (menuOpened)="onMenuOpened()" (menuClosed)="onMenuClosed()">
    <app-feather-icons [icon]="'bell'" [class]="'header-icon'"></app-feather-icons>
    @if(notifications.length > 0 && !isReaded()){
        <span class="label-count bg-orange"></span>
    }
</button>
<mat-menu #notificationMenu="matMenu" class="nfc-menu custom-nfc-menu">
    <div class="nfc-header">
        <h5 class="mb-0">{{'header.notification.list.header.title' | translate}}</h5>
        <a class="nfc-mark-as-read" (click)="$event.stopPropagation(); onMarkAllasRead()">{{'header.notification.list.header.markallasread' | translate}}</a>
    </div>
    <div class="nfc-dropdown">
        <ng-scrollbar style="height: 350px" visibility="hover">
            <div class="noti-list header-menu">
                <div class="menu">
                    <div>
                        @for (notification of notifications; track notification; let i = $index) {
                            <button mat-menu-item (click)="$event.preventDefault(); $event.stopPropagation();" class="nfc-read">
                                <ng-container [ngTemplateOutlet]="notificationTemplate" [ngTemplateOutletContext]="{notification: notification, index: i}"></ng-container>
                            </button>
                        }
                    </div>
                </div>
            </div>
        </ng-scrollbar>
    </div>
    <div class="nfc-footer">
        <a [routerLink]="'/dashboard'" class="nfc-read-all">{{'header.notification.list.footer.text' | translate}}</a>
    </div>
</mat-menu>

<ng-template #notificationTemplate let-notification="notification" let-index="index">
    <ng-container [ngTemplateOutlet]="notificationIcon" [ngTemplateOutletContext]="{notificationType: notification.notificationType}"></ng-container>
    <span class="menu-info">
        @if(notification.notificationType !== undefined){
            <span class="menu-title">{{ ('enum.NotificationTypeEnum.' + notification.notificationType) | translate:{notificationParam: notification.notificationParam ?? ''} }}</span>
            <span class="menu-desc">
                <em class="material-icons">access_time</em> {{ notification.createdAt | timeAgoPipe}}
            </span>
        }
    </span>
    <span class="nfc-close" (click)="onRemoveNotification(index); $event.stopPropagation()">
        <app-feather-icons [icon]="'x'" [class]="'user-menu-icons'" [title]="index"></app-feather-icons>
    </span>
</ng-template>

<ng-template #notificationIcon let-notificationType="notificationType">
    <span class="table-img msg-user">
        @if(
            notificationType === NotificationType.BlockCheckComplete
            || notificationType === NotificationType.BlockchainCheckSuccessful
            || notificationType === NotificationType.FileAuthenticationSuccessful
            || notificationType === NotificationType.IntegrityCheckSuccessful
        ){
            <em class="fas fa-check-circle nfc-type-icon font-20 nfc-green"></em>
        }
        @else if(
            notificationType === NotificationType.BlockchainCheckFailed
            || notificationType === NotificationType.FileAuthenticationFailed
            || notificationType === NotificationType.IntegrityCheckFailed
        ){
            <em class="fas fa-exclamation-circle nfc-type-icon font-20 nfc-red"></em>
        }
        @else {
            <em class="fas fa-info-circle nfc-type-icon font-20 nfc-blue"></em>
        }
    </span>
</ng-template>
